import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import AdSense from 'react-adsense';
import { Helmet } from "react-helmet";
import axios from 'axios';
import { Cookies } from '../../../index.js';
import { alert_error, alert_success } from "../../../AppContext.js";
import { useParams, useNavigate, Link } from 'react-router-dom';
import Orders_account from './orders';
import Orders_test from './orders_test';
import Options from '../../../shop/ai/options.jsx';
import Nhatkyaccount from '../../../nhatkyorders';
import Post_content from '../../../community/content/Blog_posts.jsx';
import Lists_home from './services/lists_home.jsx';
import Api_docs from "../../orders/api_docs.jsx";
import Shop_info from '../../../order/account/sellers/shop/shop_info.jsx';

const Account_home = () => {
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const { slug_1, slug_2, slug_3 } = useParams();
    return (
        <>
            {
                slug_2 &&
                (<>
                    {slug_2 === 'orders' && (<> <Orders_account /></>)}
                    {slug_2 === 'nhatkyaccount' && (<> <Nhatkyaccount /></>)}
                    {slug_2 === 'accounts_history' && (<> <Nhatkyaccount /></>)}
                    {slug_2 === 'support' && (<> <Post_content mode={'telegram'} show_adsense={'YES'} channel={'freefltiktok'} id_post={'184'} /></>)}
                    {slug_2 === 'home' && (<><Options /></>)}
                    {slug_2 === 'test' && (<><Orders_test /></>)}
                    {((slug_2 === 'play' || slug_2 === 'search') && slug_3 !== 'shop') && (<> <Lists_home /></>)}
                    {(slug_2 === 'api' && slug_3 === 'services') && (<> <Api_docs category="accounts_product_services" /></>)}
                    {(slug_2 === 'api' && slug_3 === 'orders') && (<> <Api_docs category="accounts_product_orders" /></>)}
                    {(slug_3 === 'shop') && (<> <Shop_info /></>)}
                    {(slug_2 === 'p2p') && (<> Đang phát triển</>)}

                </>)
            }
        </>
    );
};

export default Account_home;
